// Upper bound for waiting on images so printing can never hang
const PRINT_IMAGE_TIMEOUT_MS = 3000;

// Resolves once all images inside the activity are loaded (or after the
// timeout), so the print dialog does not capture half-loaded images. Lazy
// print-only images (e.g. the tiles of the image grid) are switched to eager
// first: hidden lazy images would otherwise never start loading.
export function waitForActivityImages(): Promise<void> {
  const images = Array.from(
    document.querySelectorAll<HTMLImageElement>(".activity img"),
  );
  images.forEach((img) => {
    if (img.loading === "lazy") img.loading = "eager";
  });
  const loaded = Promise.all(
    images.map((img) =>
      img.complete ? Promise.resolve() : img.decode().catch(() => undefined),
    ),
  ).then(() => undefined);
  const timeout = new Promise<void>((resolve) =>
    setTimeout(resolve, PRINT_IMAGE_TIMEOUT_MS),
  );
  return Promise.race([loaded, timeout]);
}
